/* eslint-disable import/no-anonymous-default-export */
import SystemDataConstants from './systemDataConsts';

const initialState = {
  status: '',
  links: [],
  banners: [],
  businessInfo: {},
  mediaRegistry: [],
  categories: [],
  language: 'en',
  dir: 'ltr',
  // language: 'he',
  // dir: 'rtl',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SystemDataConstants.UPDATE_SYSTEM_DATA: {
      return {
        ...state,
        ...action.payload, // This merges { language: 'en', dir: 'ltr' } into the state
      };
    }
    // Links
    case SystemDataConstants.SYSTEM_SET_LINKS: {
      return {
        ...state,
        status: 'success',
        links: Array.isArray(action.payload) ? action.payload : [],
      };
    }
    case SystemDataConstants.SYSTEM_CLEAR_LINKS: {
      return {
        ...state,
        status: 'success',
        links: [],
      };
    }

    // Banners
    case SystemDataConstants.SYSTEM_SET_BANNERS: {
      return {
        ...state,
        status: 'success',
        banners: Array.isArray(action.payload) ? action.payload : [],
      };
    }
    case SystemDataConstants.SYSTEM_CLEAR_BANNERS: {
      return {
        ...state,
        status: 'success',
        banners: [],
      };
    }

    // Business Info
    case SystemDataConstants.SYSTEM_SET_BUSINESS_INFO: {
      return {
        ...state,
        status: 'success',
        businessInfo: action.payload && typeof action.payload === 'object' ? action.payload : {},
      };
    }
    case SystemDataConstants.SYSTEM_CLEAR_BUSINESS_INFO: {
      return {
        ...state,
        status: 'success',
        businessInfo: {},
      };
    }

    // --- NEW: Media Registry / Gallery ---
    case SystemDataConstants.SYSTEM_SET_MEDIA_REGISTRY: {
      return {
        ...state,
        status: 'success',
        mediaRegistry: Array.isArray(action.payload) ? action.payload : [],
      };
    }

    case SystemDataConstants.SYSTEM_CLEAR_MEDIA_REGISTRY: {
      return {
        ...state,
        status: 'success',
        mediaRegistry: [],
      };
    }

    // Categories
    case SystemDataConstants.SYSTEM_SET_CATEGORIES: {
      return {
        ...state,
        status: 'success',
        categories: Array.isArray(action.payload) ? action.payload : [],
      };
    }

    case SystemDataConstants.SYSTEM_CLEAR_CATEGORIES: {
      return {
        ...state,
        status: 'success',
        categories: [],
      };
    }

    default:
      return state;
  }
};